import { useState, useEffect, useCallback } from 'react'
import axios from "axios"

const useForm = () => {
  const [submitting, setSubmitting] = useState(false)
  const [submitted, setSubmitted] = useState(false)
  const [values, setValues] = useState({})
  const [success, setSuccess] = useState(false)

  const handleSubmit = e => {
    e.preventDefault()
    setSubmitting(true)
    const data = new FormData(e.target)
    const newValues = {}
    for (var pair of data.entries()) {
      newValues[pair[0]] = pair[1]
    }
    setValues(newValues)
    setSubmitted(true)
  }

  const sendValues = useCallback(() => {
    /**
     * Code for submitting form values
     * via an external API goes here.
     */
    axios({
      method: "post",
      url: "https://getform.io/f/6dfed1c5-0530-49f9-9dfb-275d458ea7a7",
      data: values
    })
    .then(r => {
      setSuccess(true);
    })
    .catch(r => {
      setSuccess(false);
    })
    setSubmitting(false)
  }, [values])

  useEffect(() => {
    if (submitted) {
      sendValues()
    }
  }, [submitted, sendValues])

  return {
    handleSubmit,
    submitting,
    submitted,
    success
  }
}

export default useForm
